export default __webpack_public_path__ + "static/choices-3b5c52fc3d9b0aade92568617c48e557.png";